import { appendHistoricalTimelineItems } from './items/historical.js';
import { collapseArtifactStatusItems } from './items/artifactStatusProjection.js';
import { appendStreamingTimelineItems } from './items/streaming.js';
import { reconcileProcessItems } from './processProjection.js';

function arrayValue(value) {
  return Array.isArray(value) ? value : [];
}

function objectValue(value) {
  return value && typeof value === 'object' ? value : {};
}

function selectHistoricalMessages(messages, streaming) {
  const replaceAssistantMessageId = String(streaming.replaceAssistantMessageId || '').trim();
  return replaceAssistantMessageId
    ? messages.filter((message) => (
      String(message?.message_id || '').trim() !== replaceAssistantMessageId
    ))
    : messages;
}

function appendUiCards(items, uiCards) {
  if (uiCards.length === 0) {
    return;
  }
  items.push({
    id: 'conversation-ui-cards',
    type: 'ui_cards',
    cards: uiCards,
  });
}

/**
 * DOC HELPER — OBJ-09 timeline assembly boundary.
 *
 * Timeline items are projections of persisted/streamed backend artifacts. This
 * builder must not infer workflow authority such as waiting_user from payload
 * shape; such states must arrive as explicit backend trace/status fields.
 */
export function buildTimelineItems(state = {}, options = {}) {
  const messages = arrayValue(state.messages);
  const uiCards = arrayValue(state.uiCards);
  const executionCards = arrayValue(state.executionCards);
  const streaming = objectValue(state.streaming);
  const loading = Boolean(options?.loading);

  const items = [];
  appendHistoricalTimelineItems(items, selectHistoricalMessages(messages, streaming));
  appendUiCards(items, uiCards);

  appendStreamingTimelineItems(items, {
    streaming,
    executionCards,
    loading,
  });

  const collapsedItems = collapseArtifactStatusItems(reconcileProcessItems(items));
  return {
    isEmpty: collapsedItems.length === 0,
    items: collapsedItems,
  };
}

export default buildTimelineItems;
